import { formatDate } from './bits.jsx';
import { safeHtml } from '../../../../../utils/safeHtml';

/* One tab. A job profile stores its batches as a bare array of ids --
   no names come back with the record -- so there is nothing to list
   that a reader could act on, and a tab of raw ObjectIds is worse than
   no tab. If the endpoint starts populating batchIds, this gets a
   Batches panel the same shape as EventView's. */
export default function JobView({ entity }) {
  return (
    <>
      <dl className="quiz-facts">
        <div>
          <dt>Organisation</dt>
          <dd>{entity?.organizationName || '—'}</dd>
        </div>
        <div>
          <dt>Location</dt>
          <dd>{entity?.jobLocation || '—'}</dd>
        </div>
        <div>
          <dt>Package</dt>
          <dd>{entity?.package || entity?.salary || 'Confidential'}</dd>
        </div>
        <div>
          <dt>Department</dt>
          <dd>{entity?.department || '—'}</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd>{entity?.jobPositionStatus || entity?.status || '—'}</dd>
        </div>
        <div>
          <dt>Closes</dt>
          <dd>{formatDate(entity?.endDate)}</dd>
        </div>
      </dl>

      {entity?.jobDescription && (
        <>
          <h5 className="pgm-section-title">Description</h5>
          {/* The description is HTML from the job form: rendered as HTML
              (as text it printed its own tags), sanitised first. A div,
              since it brings its own paragraphs and lists. */}
          <div className="lp-prose" dangerouslySetInnerHTML={safeHtml(entity.jobDescription)} />
        </>
      )}
    </>
  );
}
